export const ENVIRONMENT_TYPE = 'PRODUCTION';
export const AUTH_API_KEY = 'da2-g4s4xww5t5dorkyfwsl6f4xghy';
export const APP_ID = 'SCHEDULING_INTERFACE';
export const APP_DISPLAY_NAME = 'SCHEDULING';
export const AUTH_PRIMARY_USER_TYPE = 'AD';
export const AUTH_SECONDARY_USER_TYPE = 'EXTERNAL';
export const NO_ACTIVITY_TIMEOUT = null;
export const RE_AUTHENTICATION_ENABLED = true;
export const DEFAULT_COLOR_SCHEME = 'DARK';
export const DEFAULT_MOLD_CHANGE_TIME_MINUTES = 60;
export const DEFAULT_COLOR_CHANGE_TIME_MINUTES = 30;
export const DEFAULT_JOB_CHANGE_TIME_MINUTES = 5;
export const MACHINE_NAME_LABEL_WIDTH = 110;